import { useState } from 'react';

export interface DragItem {
  id: string;
  type: 'field' | 'section';
  data: any;
}

export interface DropResult {
  sectionId: string;
  column?: 0 | 1;
  index: number;
}

export function useDragAndDrop() {
  const [draggedItem, setDraggedItem] = useState<DragItem | null>(null);
  const [dropTarget, setDropTarget] = useState<DropResult | null>(null);

  const handleDragStart = (item: DragItem) => {
    setDraggedItem(item);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDropTarget(null);
  };

  const handleDragOver = (target: DropResult) => {
    setDropTarget(target);
  };

  const handleDrop = (target: DropResult, onDrop: (item: DragItem, target: DropResult) => void) => {
    if (draggedItem) {
      onDrop(draggedItem, target);
    }
    handleDragEnd();
  };

  return {
    draggedItem,
    dropTarget,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDrop,
    isDragging: !!draggedItem
  };
}
